module.exports = __webpack_public_path__ + "img/index-7.4f08cc72.png";